<template>
  <div class="associate-brands">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-lianmengyingxiao" fill="#fff"></use>
      </svg>
    </breadcrumbs>
    <a-spin :spinning="exportLoading">

      <div class="content-wrapper">
        <div class="export-btn-wrapper">
           <a-typography-title :level="5"> Associate Brand</a-typography-title>
       
          <div class="content-main" ref="mainRef">
            <a-dropdown :getPopupContainer="() => mainRef">
              <template #overlay>
                <artmisads-dropdown-menu @click="handleExportClick">
                  <a-menu-item key="all">Export ASIN Info</a-menu-item>
                </artmisads-dropdown-menu>
              </template>
              <artmisads-button-special class="export-btn">
                <svg class="icon daochu" aria-hidden="true">
                  <use xlink:href="#icon-daochu"></use>
                </svg>
                <span class="btn-text">Export</span>
                <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                  <use xlink:href="#icon-jiantou-xia-cu"></use>
                </svg>
              </artmisads-button-special>
            </a-dropdown>
          </div>
        </div>
        <div class="table-head">
          <!-- <a-space> -->
            <buttonGroups :pagination="{
              total: tableTotal,
              page: params.page,
              size: params.size,
            }" :tableData="data" @pageChange="onPageChange" />
            <div class="statusFilter" ref="marketplaceRef">
              <span style="margin-right: 8px;">Marketplace:</span>
              <artmisads-select style="width: 160px" v-model:value="marketplace" @change="onChangeCountry"
                :getPopupContainer="() => $refs.marketplaceRef">
                <a-select-option value="">All</a-select-option>
                <template v-for="option in COUNTRY_BASE" :key="option.countryCode">
                  <a-select-option class="country-select-item" :value="option.host">
                    <Icon :name="option.icon"></Icon>
                    <span>{{ option.host }}</span>
                  </a-select-option>
                </template>
              </artmisads-select>
            </div>

          <!-- </a-space> -->

          <!-- <a-space class="filters"> -->
            <a-input-search v-model:value="keyword" placeholder="Search..." allow-clear @search="onSearch"
              @enter="onSearch" style="width: 180px">
            </a-input-search>

            <div class="statusFilter">
              <span style="margin-right: 8px;">Status:</span>
              <artmisads-select v-model:value="status" style="width: 130px;" @change="onStatusChange" trigger="click">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="active">Active</a-select-option>
                <a-select-option value="inactive">Inactive</a-select-option>
              </artmisads-select>
            </div>
          <!-- </a-space> -->
          <!-- <a-space> -->
            <div ref="sortRef">
              <span style="margin-right: 8px;">Sort:</span>
              <artmisads-select style="width: 185px;" class="sort-select flex-right" v-model:value="sort"
                @change="(option) => setFilter(option)" :getPopupContainer="() => $refs.sortRef">
                <a-select-option value="lastCommissionRateAsc">
                  <Icon name="paixu1" class="iconAsc paixuIcon" />
                  <span class="paixuText">Commission</span>
                </a-select-option>
                <a-select-option value="lastCommissionRateDesc">
                  <Icon name="paixu1" />
                  <span class="paixuText">Commission</span>
                </a-select-option>
                <a-select-option value="collaborationPeriodAsc">
                  <Icon name="paixu1" class="iconAsc paixuIcon" />
                  <span class="paixuText">Partnership Period</span>
                </a-select-option>
                <a-select-option value="collaborationPeriodDesc">
                  <Icon name="paixu1" />
                  <span class="paixuText">Partnership Period</span>
                </a-select-option>

              </artmisads-select>
            </div>
          <!-- </a-space> -->

        </div>


        <artmisads-table :loading="loading" :columns="columns" :data-source="data" row-key="id" :pagination="{
          total: tableTotal,
          current: params.page,
          pageSize: params.size,
          showTotal: (total, range) => `Total ${total} items`,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200']
        }" :change="onChangePage">
          <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'currentCommissionRate'">
              <span>
                Commission Rate
              </span>
              <a-popover>
                <template #content>

                  <p style="width: 400px;">Brand owners can set a universal Commission Rate that applies to all products
                    under the brand, or set individual commission rates for specific products.</p>
                  <p style="width: 400px;">This section displays the brand’s universal Commission Rate.</p>
                  <p style="width: 400px;">For product-specific commission rates, please refer to individual product
                    pages.</p>

                </template>
                <Icon name="wenhao-tianchong" class="wenhao" />
              </a-popover>
            </template>
            <template v-if="column.dataIndex === 'products'">
              <span>
                Active Products
              </span>
              <a-popover>
                <template #content>
                  <p style="width: 400px;">Once a brand authorizes and enables Associate partnerships, only products set
                    to Active status by the brand are eligible for commissions during the partnership period.</p>
                  <p style="width: 400px;">If a brand changes a product’s status from Active to Inactive, the update
                    will take effect after a 3-business-day buffer period.</p>
                  <p style="width: 400px;">The number of Active products displayed here includes all variants of each
                    product. Promotions of product variants are also eligible for commissions.</p>
                </template>
                <Icon name="wenhao-tianchong" class="wenhao" />
              </a-popover>
            </template>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'brand'">
              <div class="brand-name" @click="handleViewBrand(record.brandVO)">
                <LogoImage :logoUrl="record.brandVO.logoImageUrl" :brandName="record.brandVO.amazonBrandName" />
                <div class="product-title">
                  <span>{{ record.hasDuplicate ? record.brandVO.amazonBrandName + '(' +
                    record.brandVO.amazonProfileAccountInfoName + ')' : record.brandVO.amazonBrandName }}</span>
                  <div class="asin">
                    {{ record.brandVO.biography }}
                  </div>
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'marketplace'">
              <div class="marketplace-info">
                <Icon :name="countryCode(record.countryCode)?.icon"></Icon>
                {{ countryCode(record.countryCode)?.host }}
              </div>
            </template>
            <template v-if="column.dataIndex === 'products'">
              <a style="text-decoration: underline;color: black;" href="javascript:void(0)" @click="handleViewProducts(record)">
                {{ record.brandVO.associateActiveProductCount }}
              </a>
            </template>
            <template v-if="column.dataIndex === 'status'">
              <Status :text="record.status" :noBorder="true" :type="record.status" style="width: auto;" />
            </template>
            <template v-if="column.dataIndex === 'collaborationPeriod'">
              {{ record.startDateStr }} ~ {{ record.endDateStr }}
            </template>
            <template v-if="column.dataIndex === 'action'">
              <artmisads-select-button @click="handleViewHistory(record)">History</artmisads-select-button>
            </template>
          </template>
        </artmisads-table>
      </div>
    </a-spin>
  </div>
  <history-model ref="historyModelRef" />
</template>

<script setup lang="jsx">
import { ref, watch } from 'vue'
import breadcrumbs from "~/components/breadcrumbs.vue"
import { associateCentralApi } from '~/server/index'
import buttonGroups from '~/components/buttonGroups.vue'
import LogoImage from '~/components/LogoImage.vue'
import Status from '~/components/Status.vue'
import HistoryModel from '~/components/historyModel.vue'
import { useRouter } from 'vue-router'
import { COUNTRY_BASE } from '~/contants/common'
import Icon from '~/components/Icon.vue'
import { countBrandNames } from '~/utils'
const router = useRouter()
const mainRef = ref()

const breadcrumbsData = {
  title: "Associate Brands",
  hasTitleIcon: true,
  color: "#4682FA",
  des: "The Brands that have authorized your media to promote through Associate links",

  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Associate Central",
      path: "/publisher/associateCentral/associateBrands",
    },
    {
      name: "Associate Brands",
      path: "/publisher/associateCentral/associateBrands",
    },
  ],
}
const columns = ref([
  {
    title: 'Brand',
    dataIndex: 'brand',

  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
  },
  {
    title: 'Commission Rate',
    dataIndex: 'currentCommissionRate',
    width: '200px',
    customRender: ({ text }) => {
      return (
        <div>
          {text ? text + '%' : '--'}
        </div>
      )
    }
  },
  {
    title: 'Active Products',
    dataIndex: 'products',
    width: '200px',
  },
  {
    title: 'Partnership Status',
    dataIndex: 'status',
  },
  {
    title: 'Partnership Period',
    dataIndex: 'collaborationPeriod',
  },
  {
    title: 'Action',
    dataIndex: 'action',

  }
])
const data = ref([])
const tableTotal = ref(0)
const loading = ref(false)
const params = ref({
  page: 1,
  size: 10,
  keyword: '',
  status: '',
  marketplace: 'amazon.com',
  sortField: 'commission',
  sortDirection: 'asc'
})
const sort = ref('lastCommissionRateAsc')
const keyword = ref('')
const status = ref('')
const marketplace = ref('amazon.com')
const exportLoading = ref(false)
const getList = () => {
  loading.value = true
  associateCentralApi.getAssociateBrandList(params.value).then(res => {
    const brandNameCount = countBrandNames(res.data.data, 'brandVO.amazonBrandName')
    data.value = res.data.data.map(brand => ({
      ...brand,
      hasDuplicate: brand.brandVO.amazonBrandName && brandNameCount[brand.brandVO.amazonBrandName] > 1
    }))

    tableTotal.value = res.data.total
  }).finally(() => {
    loading.value = false
  })
}
const onPageChange = current => {
  params.value.page = current
}
const onChangePage = (data) => {
  params.value.page = data.current
  params.value.size = data.pageSize
}
const onSearch = () => {
  params.value.keyword = keyword.value
  params.value.page = 1
  params.value.size = 10
}
const onStatusChange = (value) => {
  params.value.status = value
  params.value.page = 1
  params.value.size = 10
}
const onChangeCountry = (value) => {

  params.value.marketplace = value
  params.value.page = 1
  params.value.size = 10
}
const handleViewProducts = (record) => {
  router.push({
    path: '/publisher/products',
    query: {
      brandName: record.brandVO.amazonBrandName,
      countryCode: record.countryCode,
      partnered: true,
      hideVariationProducts: true
    }
  })
}
const historyModelRef = ref(null)
const countryCode = (countryCode) => {
  return COUNTRY_BASE.find(item => item.countryCode === countryCode)
}
const handleViewBrand = (brand) => {
  window.open(`/publisher/brands/${brand.id}`, '_blank')
}
const handleViewHistory = (record) => {
  historyModelRef.value.showModal(record, 'associateBrands')
}
const handleExportClick = async ({ key }) => {
  exportLoading.value = true
  await associateCentralApi.exportAssociate({
    qs: {
      marketplace: params.value.marketplace,
      keyword: params.value.keyword,
    },
    fileName: 'Associate ASINs'
  })
  setTimeout(() => {
    exportLoading.value = false
  }, 1000)
  //  exportLoading.value = false
}
const setFilter = (option) => {
  if (option === 'lastCommissionRateAsc') {
    params.value.sortField = 'commission'
    params.value.sortDirection = 'asc'
  } else if (option === 'lastCommissionRateDesc') {
    params.value.sortField = 'commission'
    params.value.sortDirection = 'desc'
  } else if (option === 'collaborationPeriodAsc') {
    params.value.sortField = 'partnership_period'
    params.value.sortDirection = 'asc'
  } else if (option === 'collaborationPeriodDesc') {
    params.value.sortField = 'partnership_period'
    params.value.sortDirection = 'desc'
  }
}
watch(params, (newVal) => {
  getList()
}, { deep: true, immediate: true })
</script>
<style scoped lang="less">
@import '../../../../assets/less/ellipsis.less';

.wenhao {
  color: rgba(15, 6, 41, 0.3) !important;
  fill: rgba(15, 6, 41, 0.3) !important;
}

:deep(.ant-popover-inner-content) {
  width: 300px !important;

  p {
    width: 300px !important;
  }
}

// .ant-popover {
//     .ant-popover-inner {

//     }
//   }
:deep(.ant-popover .ant-popover-inner) {
  width: 300px !important;
}

.iconAsc {
  transform: rotate(180deg);
}

.content-main {

  >button {
    align-self: center;
    cursor: pointer;
    display: flex;

    .jiantou {
      width: 16px;
      height: 16px;
      fill: var(--dark-3);
      margin-left: 8px;
    }

    .daochu {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      fill: var(--dark-1);
    }

    >svg {
      align-self: center;
    }

    >span {
      align-self: center;
    }

    .btn-text {
      align-self: center;
      font-weight: 500;
      line-height: 20px;
      margin-right: 8px;
    }
  }
}

.content-wrapper {
  display: block !important;

  .marketplace-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .table-head {
    display: flex;
    height: 64px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    .statusFilter {
      position: relative;
      z-index: 2;
      margin-left: 18px;
      display: flex;
      align-items: center;
      // opacity: 0.7;
      font-family: Sora, sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: var(--dark-2);
      letter-spacing: 0.4px;
      line-height: 20px;
    }

    .filters {
      display: flex;
      justify-content: space-between;


    }

  }

  .brand-name {
    display: flex;
    align-items: center;

    .product-title {
      flex: 1;
      margin-left: 12px;
      max-width: 200px;

      >span {
        display: block;
        cursor: pointer;
        max-height: 22px;
        font-weight: 500;
        overflow: hidden;
        line-height: 22px;
        white-space: nowrap;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        text-overflow: ellipsis;
        text-decoration: underline;
      }

      >div {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        overflow: hidden;
        color: var(--dark-3);
        letter-spacing: 0.3px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .asin {
        margin-top: 2px;


      }
    }


  }
}

.export-btn-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 12px;
}
</style>